"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalVolatileStateMessage = void 0;
var GlobalVolatileStateMessage;
(function (GlobalVolatileStateMessage) {
    class OnlinePlayerCountChanged {
        constructor(nextValue) {
            this.nextValue = nextValue;
            this.__type = "OnlinePlayerCountChanged";
        }
    }
    GlobalVolatileStateMessage.OnlinePlayerCountChanged = OnlinePlayerCountChanged;
})(GlobalVolatileStateMessage = exports.GlobalVolatileStateMessage || (exports.GlobalVolatileStateMessage = {}));
